import { Box, Typography } from "@mui/material";
import { BaseMatchState } from "../../types/match";
import { styled } from "@mui/material/styles";
import colors from "../../theme/colors";
import fonts from "../../theme/fonts";
import { TEAM } from "../../types/teams";

interface SetsTableProps {
  matchState: BaseMatchState;
}

export default function SetsTable({ matchState }: SetsTableProps) {
  const playerLegWins = (team: TEAM): JSX.Element[] => {
    const tds: JSX.Element[] = [];
    matchState.completed.sets.forEach((set, i) => {
      const setWins = set.legs.filter((leg) => leg.winner === team).length;
      tds.push(
        <TableEntry key={`${team}_setWins_${i}`}>
          {setWins > 0 ? setWins : "-"}
        </TableEntry>
      );
    });
    const currentWins = matchState.completed.legs.filter(
      (leg) => leg.winner === team
    ).length;
    tds.push(
      <TableEntry key={`${team}_currentSet`}>
        {currentWins > 0 ? currentWins : "-"}
      </TableEntry>
    );
    const leftOverSets = matchState.sets - tds.length;
    for (let i = 0; i < leftOverSets; i++) {
      tds.push(<TableEntry key={`${team}_leftOver_${i}`}>-</TableEntry>);
    }
    if (tds.length > matchState.sets) {
      tds.pop();
    }
    return tds;
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      width="50%"
      alignSelf="center"
    >
      <Typography
        color={colors.lightBeige}
        fontFamily={fonts.family.chalk}
        fontSize={fonts.size.medium}
      >
        Sets
      </Typography>
      <Table>
        <tbody>
          <tr style={{ backgroundColor: colors.lightBeige }}>
            {playerLegWins(TEAM.ONE)}
          </tr>
          <tr style={{ backgroundColor: "rgb(197, 98, 98)" }}>
            {playerLegWins(TEAM.TWO)}
          </tr>
        </tbody>
      </Table>
    </Box>
  );
}

const Table = styled("table")(() => ({
  width: "100%",
  maxWidth: "100%",
  borderCollapse: "collapse",
  textAlign: "center",
  borderSpacing: 0,
}));

const TableEntry = styled("td")(() => ({
  width: 20,
  padding: 0,
  border: "1px solid black",
}));
